
<div
  :class="classes(n())"
  :style="containerStyle"
>
  <div :class="classes(n('currency'))">
    {{ currencyCode }}
  </div>
  <div :class="classes(n('amount'))">
    {{ displayAmount }}
  </div>
</div>
